import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import { ITheme } from '../../../theme/types';

export const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#FFFFFF',
    color: '#000000',
    borderRadius: '0.5rem',
    fontSize: '0.875rem',
    maxWidth: '16.25rem',
    boxShadow: '0rem 0rem 1.25rem 0rem grey',
    padding: '15px',
  },
  popper: {
    zIndex: 1300,
  },
}))(Tooltip);
